
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleGoBack = () => {

    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="min-h-screen p-4 md:p-6 text-white" style={{ paddingTop: '3rem' }} dir="rtl">
      <div className="max-w-4xl mx-auto px-2 sm:px-4 md:px-0 mt-10 md:mt-0">
        <div
          className="relative mb-8 w-full max-w-6xl mx-auto"
          style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px',
            gap: '8px',
            isolation: 'isolate',
            minHeight: 'min(628px,80vh)',
            background:
              'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), #081423',
            border: '0.924351px solid rgba(40, 227, 218, 0.25)',
            boxShadow: '0px 8px 32px rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(1px)',
            borderRadius: '24px'
          }}
        >
          <div
            className="w-full h-full p-4 sm:p-6"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '24px',
              zIndex: 0
            }}
          >
            {            }
            <div
              className="w-full flex flex-col items-center justify-center gap-4"
              style={{ textAlign: 'center' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '8px'
                }}
              >
                 <div style={{ textAlign: 'right' }}>
                  <div
                    style={{
                      fontFamily: 'Alexandria',
                      fontStyle: 'normal',
                      fontWeight: 800,
                      fontSize: '20px',
                      lineHeight: '120%',
                      color: '#FFFFFF'
                    }}
                  >
                    الصفحة غير موجودة
                  </div>
                  <div
                    style={{
                      fontFamily: 'Alexandria',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      fontSize: '13px',
                      lineHeight: '150%',
                      color: 'rgba(255,255,255,0.75)'
                    }}
                  >
                    يبدو أنك حاولت الوصول إلى رابط غير متاح في همة.
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '16px',
                    gap: '8px',
                    width: '56px',
                    height: '56px',
                    background:
                      'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(255, 77, 77, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(120, 35, 46, 0.35)',
                    boxShadow: '0px 8px 32px rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(1px)',
                    borderRadius: '100px'
                  }}
                >
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="9" stroke="#FFFFFF" strokeWidth="1.5" />
                    <path
                      d="M12 8v5"
                      stroke="#FF4D4D"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                    />
                    <circle cx="12" cy="16" r="1" fill="#FF4D4D" />
                  </svg>
                </div>


              </div>

              {                     }
              <div
                style={{
                  fontFamily: 'Alexandria',
                  fontStyle: 'normal',
                  fontWeight: 900,
                  fontSize: '64px',
                  lineHeight: '100%',
                  letterSpacing: '0.12em',
                  color: '#FFFFFF',
                  textShadow: '0 0 30px rgba(40,227,218,0.45)'
                }}
              >
                404
              </div>

              {                               }
              {location?.pathname && (
                <div
                  style={{
                    maxWidth: '480px',
                    fontFamily: 'Alexandria',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '170%',
                    color: 'rgba(255,255,255,0.85)'
                  }}
                >
                  المسار الذي حاولت الوصول إليه:
                  <span
                    style={{
                      display: 'inline-block',
                      direction: 'ltr',
                      textAlign: 'left',
                      marginRight: '6px',
                      padding: '3px 8px',
                      borderRadius: '999px',
                      background: 'rgba(0,0,0,0.35)',
                      border: '1px solid rgba(255,255,255,0.15)',
                      fontFamily: 'monospace',
                      fontSize: '12px'
                    }}
                  >
                    {location.pathname}
                  </span>
                  غير معروف داخل المنصة.
                </div>
              )}

              <p
                style={{
                  maxWidth: '480px',
                  fontFamily: 'Alexandria',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '15px',
                  lineHeight: '170%',
                  color: 'rgba(255,255,255,0.78)',
                  marginTop: '4px'
                }}
              >
                بإمكانك الرجوع للصفحة السابقة، أو العودة للرئيسية ومتابعة تصفّح خدمات{' '}
                <span style={{ fontWeight: 700 }}>همة</span>.
              </p>
            </div>

            {             }
            <div className="mt-6 w-full flex flex-col sm:flex-row justify-center gap-3">
              <button
                onClick={handleGoHome}
                className="w-full sm:w-auto max-w-xs"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '12px 36px',
                  gap: '8px',
                  background:
                    'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
                  borderRadius: '16px',
                  border: 'none',
                  fontFamily: 'Alexandria',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '15px',
                  lineHeight: '100%',
                  textAlign: 'center',
                  color: '#FFFFFF',
                  cursor: 'pointer'
                }}
              >
                الرجوع للصفحة الرئيسية
              </button>

              <button
                onClick={handleGoBack}
                className="w-full sm:w-auto max-w-xs"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '12px 32px',
                  gap: '8px',
                  background: 'rgba(255,255,255,0.06)',
                  borderRadius: '16px',
                  border: '1px solid rgba(255,255,255,0.18)',
                  fontFamily: 'Alexandria',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '15px',
                  lineHeight: '100%',
                  textAlign: 'center',
                  color: '#FFFFFF',
                  cursor: 'pointer'
                }}
              >
                رجوع للصفحة السابقة
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
